import { useTranslate } from "@similarweb/i18n-provider";
import { Flex } from "@similarweb/ui-components/foundations";

import type { ExtensionAdoptionStatsData } from "app/pages/sales-intelligence/modules/extension-management/types";

import { EXTENSION_ADOPTION_STATS_CARDS_CONFIG } from "./config";
import { ExtensionAdoptionStatsCard } from "./ExtensionAdoptionStatsCard";

type ExtensionAdoptionStatsCardsProps = {
    stats: ExtensionAdoptionStatsData;
};

export const ExtensionAdoptionStatsCards = ({ stats }: ExtensionAdoptionStatsCardsProps) => {
    const { translate } = useTranslate();

    return (
        <Flex
            gap="16px"
            data-automation="extension-management-adoption-stats-cards"
        >
            {EXTENSION_ADOPTION_STATS_CARDS_CONFIG.map((card) => {
                const status = card.getStatus(stats);
                return (
                    <ExtensionAdoptionStatsCard
                        key={card.dataAutomation}
                        title={translate(card.titleKey)}
                        percentage={card.getPercentage(stats)}
                        description={`${card.numerator.getValue(stats)} ${translate(card.numerator.labelKey).toLowerCase()} / ${card.denominator.getValue(stats)} ${translate(card.denominator.labelKey).toLowerCase()}`}
                        status={status}
                        badgeText={translate(`si.management.extension.adoption.status.${status}`)}
                        bottomStats={card.bottomStats.map((bs) => ({
                            label: translate(bs.labelKey),
                            value: bs.getValue(stats),
                        }))}
                        dataAutomation={card.dataAutomation}
                    />
                );
            })}
        </Flex>
    );
};
